// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sync-managemend-report-table .VueTables__search{display:flex;justify-content:space-between;width:100%}", ""]);
// Exports
module.exports = exports;
